import { render, staticRenderFns } from "./LayoutCommonTopic.vue?vue&type=template&id=2b46cb8e&"
import script from "./LayoutCommonTopic.vue?vue&type=script&lang=ts&"
export * from "./LayoutCommonTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports